var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"type":'failure',"link":{href: this.calendarUrl, remote: false, text: 'Go to Calendar'},"message":"This course can no longer be booked into."}})}
var staticRenderFns = []

export { render, staticRenderFns }